// extracted by mini-css-extract-plugin
module.exports = {"foldableText":"Provider_foldableText__2oNmM","cancelationDate":"Provider_cancelationDate__39Dr6","questionProvider":"Provider_questionProvider__3oGg9"};